import { Pipe, PipeTransform } from '@angular/core';
import {
  STATUSES_WITH_BLACK_TEXT,
  STATUS_PILL_COLOR_MAPPING,
} from '../constants/xpass-variables.constant';
import { EStatusTextColors } from '../enums/status-text-colors.enum';
import { XpassStatusLabels } from '../enums/xpass-status-labels.enum';
import { StatusPillStyleMap } from '../interfaces/status-pill-style-map.interface';

@Pipe({
  name: 'statusPillStyling',
  standalone: true,
})
export class StatusPillStylingPipe implements PipeTransform {
  transform(label: XpassStatusLabels): StatusPillStyleMap {
    const { BLACK_COLOR_HEX, WHITE_COLOR_HEX } = EStatusTextColors;

    return {
      'background-color': STATUS_PILL_COLOR_MAPPING[label],
      color: STATUSES_WITH_BLACK_TEXT.includes(label)
        ? BLACK_COLOR_HEX
        : WHITE_COLOR_HEX,
    };
  }
}
